import {type Counter} from './Counter'

/** Отмечает время окончания расчёта дельты и отправляет дельту. Работает в паре с `sendTime` */
export function timeEnd(counterId: Counter): void {
  try {
    Ya.Rum.timeEnd(counterId)
  } catch (error) {
    console.error(error)
  }
}
